// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const listAssetsApiAssetsGetParamsQOneMax = 200;

export const listAssetsApiAssetsGetParamsKindDefault = [];
export const listAssetsApiAssetsGetParamsKindMax = 50;

export const listAssetsApiAssetsGetParamsStatusDefault = [];
export const listAssetsApiAssetsGetParamsStatusMax = 50;

export const listAssetsApiAssetsGetParamsMaturityDefault = [];
export const listAssetsApiAssetsGetParamsMaturityMax = 50;

export const listAssetsApiAssetsGetParamsIndustryDefault = [];
export const listAssetsApiAssetsGetParamsIndustryMax = 50;

export const listAssetsApiAssetsGetParamsPartnerDefault = [];
export const listAssetsApiAssetsGetParamsPartnerMax = 50;

export const listAssetsApiAssetsGetParamsCountryItemMax = 10;

export const listAssetsApiAssetsGetParamsCountryDefault = [];
export const listAssetsApiAssetsGetParamsCountryMax = 50;

export const listAssetsApiAssetsGetParamsPageDefault = 1;

export const listAssetsApiAssetsGetParamsPageSizeDefault = 50;
export const listAssetsApiAssetsGetParamsPageSizeMax = 200;

export const ListAssetsApiAssetsGetParams = zod.object({
  "q": zod.union([zod.string().max(listAssetsApiAssetsGetParamsQOneMax),zod.null()]).optional(),
  "kind": zod.array(zod.enum(['platform', 'accelerator', 'framework', 'offer'])).max(listAssetsApiAssetsGetParamsKindMax).default(listAssetsApiAssetsGetParamsKindDefault),
  "status": zod.array(zod.enum(['draft', 'published', 'archived'])).max(listAssetsApiAssetsGetParamsStatusMax).default(listAssetsApiAssetsGetParamsStatusDefault),
  "maturity": zod.array(zod.enum(['concept', 'pilot', 'available'])).max(listAssetsApiAssetsGetParamsMaturityMax).default(listAssetsApiAssetsGetParamsMaturityDefault),
  "industry": zod.array(zod.uuid()).max(listAssetsApiAssetsGetParamsIndustryMax).default(listAssetsApiAssetsGetParamsIndustryDefault),
  "partner": zod.array(zod.uuid()).max(listAssetsApiAssetsGetParamsPartnerMax).default(listAssetsApiAssetsGetParamsPartnerDefault),
  "country": zod.array(zod.string().max(listAssetsApiAssetsGetParamsCountryItemMax)).max(listAssetsApiAssetsGetParamsCountryMax).default(listAssetsApiAssetsGetParamsCountryDefault),
  "stale": zod.union([zod.boolean(),zod.null()]).optional(),
  "sort": zod.union([zod.enum(['relevance', 'name', 'kind', 'updated', 'confirmed']),zod.null()]).optional(),
  "order": zod.union([zod.enum(['asc', 'desc']),zod.null()]).optional(),
  "page": zod.int().min(1).default(listAssetsApiAssetsGetParamsPageDefault),
  "page_size": zod.int().min(1).max(listAssetsApiAssetsGetParamsPageSizeMax).default(listAssetsApiAssetsGetParamsPageSizeDefault)
})

export type ListAssetsApiAssetsGetParams = zod.input<typeof ListAssetsApiAssetsGetParams>;
export type ListAssetsApiAssetsGetParamsOutput = zod.output<typeof ListAssetsApiAssetsGetParams>;
